export class PaypalPlanRequestBodyModel{
    public id:string="";
    public product_id:string="";
    public name:string="";
    public status:string="";
    public description:string="";
    public billing_cycles:billing_cycle[];
    public payment_preferences:payment_preferences;
    public taxes:taxes;
    public quantity_supported:Boolean;
  
}

export enum PlanStatus
{
    CREATED,
    INACTIVE,
    ACTIVE
}

export enum tenure_type
    {
        REGULAR,
        TRIAL
    }

    export enum interval_unit
    {
        DAY,
        WEEK,
        MONTH,
        YEAR
    }

    
    export enum setup_fee_failure_action
    {
        CONTINUE,
        CANCEL

    }

export class billing_cycle{
    constructor(
        private pricing_scheme:pricing_scheme,
        private frequency:frequency,
        private tenure_type:string,
        private sequence:number,
        private total_cycles:number,


    ){

    }

}

export class frequency{
    
        private language: string;
    constructor(
        private interval_unit: string,
        private interval_count: number
    ){

    }
}
export class pricing_scheme{
    
        public version: number;
        public create_time: string;
        public update_time: string;
    constructor(
        private fixed_price: money
        
    ){

    }
    
}

export class payment_preferences{
    constructor(
        private auto_bill_outstanding: boolean,
        private setup_fee: money,
        private setup_fee_failure_action: string,
        private payment_failure_threshold: number,
        
    ){
        
    }
}
export class taxes{
    constructor(
        private percentage: string,
        private inclusive: boolean,
    ){}
}
export class money{
    constructor(
        private currency_code: string,
        private value: string,
    ){}
}


